import script from "./BottomBarNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomBarNavigation.vue?vue&type=script&setup=true&lang=js"

import "./BottomBarNavigation.vue?vue&type=style&index=0&id=760ef29d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760ef29d"]])

export default __exports__